import {
    DataTable,
    DateField,
    ExportButton,
    List,
} from '@/components/admin';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { Calendar, Truck } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { TopToolbar } from '../../layout/TopToolbar';
import { PermissionCreateButton } from '../shared/PermissionCreateButton';
import { StatusBadge } from '../shared/StatusBadge';

const StatusCell = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <StatusBadge status={record.status} />;
};

const TransportBadge = () => {
    const record = useRecordContext();
    if (!record?.mode_of_transport) return <span className="text-xs text-muted-foreground">—</span>;
    return (
        <Badge variant="outline" className="text-[10px] font-semibold bg-muted text-muted-foreground border-border">
            <Truck className="w-3 h-3 mr-1" />
            {record.mode_of_transport}
        </Badge>
    );
};

const DCListActions = () => (
    <TopToolbar>
        <ExportButton />
        <PermissionCreateButton permission="manage_documents" label="New Challan" />
    </TopToolbar>
);

import { getGlobalFilters } from '../shared/GlobalFilterBar';

const dcStatusChoices = [
    { id: 'draft', name: 'Draft' },
    { id: 'sent', name: 'Sent' },
    { id: 'dispatched', name: 'Dispatched' },
    { id: 'delivered', name: 'Delivered' },
];

export const DCList = () => (
    <List
        title="Delivery Challans"
        actions={<DCListActions />}
        filters={getGlobalFilters(dcStatusChoices, "DC Status")}
        sort={{ field: 'challan_date', order: 'DESC' }}
        className="p-6"
        filtersLayout="two-rows"
    >
        <Card className="border-none shadow-sm overflow-hidden">
            <DataTable rowClick="show">
                <DataTable.Col
                    source="reference"
                    label="Challan No."
                    className="font-mono font-bold text-foreground"
                />
                <DataTable.Col label="Date">
                    <div className="flex items-center gap-2 text-muted-foreground text-xs">
                        <Calendar className="w-3 h-3" />
                        <DateField source="challan_date" />
                    </div>
                </DataTable.Col>
                <DataTable.Col source="challan_type" label="Type" className="font-medium" />
                <DataTable.Col label="Transport">
                    <TransportBadge />
                </DataTable.Col>
                <DataTable.Col source="contact_person" label="Contact Person" className="text-sm" />
                <DataTable.Col label="Status">
                    <StatusCell />
                </DataTable.Col>
                <DataTable.Col label="Created">
                    <DateField source="created_at" showTime showDate />
                </DataTable.Col>
            </DataTable>
        </Card>
    </List>
);
